<div class="intro-loading-box">
  <div class="loading-contents-box">
    <div class="logo-box">
      <div class="loading-text-box">
        <img
          class="first-icon double-icon"
          libSrc="/assets/icons/loading-os-icon.png"
          alt=""
        />
        <img
          class="second-icon double-icon"
          libSrc="/assets/icons/loading-os-color-icon.png"
          alt=""
        />
      </div>

      <div class="center-logo-box">
        <div class="symbol-logo-box">
          <div class="symbol-inner-logo-box">
            <img
              class="second-show-symbol"
              libSrc="/assets/icons/loading-symbol1-icon.png"
              alt=""
            />

            <img
              class="first-show-symbol"
              libSrc="/assets/icons/loading-symbol2-icon.png"
              alt=""
            />
          </div>
        </div>

        <div class="loading-text-box center-loading-text-box">
          <img
            class="center-o-icon first-icon single-icon"
            libSrc="/assets/icons/loading-o-icon.png"
            alt=""
          />

          <img
            class="center-o-color-icon second-icon single-icon"
            libSrc="/assets/icons/loading-o-color-icon.png"
            alt=""
          />
        </div>
      </div>

      <div class="loading-text-box margin-left">
        <img
          class="first-icon double-icon"
          libSrc="/assets/icons/loading-so-icon.png"
          alt=""
        />
        <img
          class="second-icon double-icon"
          libSrc="/assets/icons/loading-so-color-icon.png"
          alt=""
        />
      </div>
    </div>

    <div class="loading-percent-box">
      <p class="loading-percent-count">00</p>
      <p class="loading-percent">%</p>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
